import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export const useGoogleFileSearchStores = (provider = "google", enabled = true) => {
  const auth = useAuth();
  const userContext = useUser();
  const workspaceId = userContext?.activeWorkspaceId;

  return useQuery({
    queryKey: ["google-file-search-stores", workspaceId, provider],
    queryFn: async () => {
      const response = await fetch(
        `${API_URL}/api/dashboard/v2/google-file-search-store/list?workspace_id=${workspaceId}&provider=${provider}`,
        {
          headers: authHeader(auth!.userToken!),
        },
      ).then(handleResponse);

      if (response && typeof response === "object" && "success" in response) {
        if (response.success === false) {
          const errorMessage =
            (response as { message?: string }).message ||
            "No file search stores found for this workspace.";
          throw new Error(errorMessage);
        }
      }

      return response;
    },
    enabled: !!workspaceId && enabled,
  });
};
